var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg5Mobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 733,
    viewBox: "0 0 360 733",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_447_110792)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 406.581,
    cy: 763.626,
    rx: 406.581,
    ry: 763.626,
    transform: "matrix(0.697674 0.716415 -0.683113 0.730313 543.344 224.326)",
    fill: "url(#paint0_linear_447_110792)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_447_110792",
    x: -732.141,
    y: 0.382141,
    width: 2075.01,
    height: 2145.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 221.805,
    result: "effect1_foregroundBlur_447_110792"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_447_110792",
    x1: 406.581,
    y1: 0,
    x2: 406.581,
    y2: 1527.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22D695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D695",
    stopOpacity: 0.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg5Mobile);
export default __webpack_public_path__ + "static/media/bg5-mobile.86bb3d46eafa66e2ece9bc5689d6b761.svg";
export { ForwardRef as ReactComponent };